const bustSizeOptions = [
    { value: "", label: "Bust Size" },
    { value: "6F", label: "60G" },
    { value: "6FF", label: "60H" },
    { value: "6G", label: "60I" },
    { value: "6GG", label: "60J" },
    { value: "6H", label: "60K" },
    { value: "8F", label: "65G" },
    { value: "8FF", label: "65H" },
    { value: "8G", label: "65I" },
    { value: "8GG", label: "65J" },
    { value: "8H", label: "65K" },
    { value: "8J", label: "65M" },
    { value: "10E", label: "70F" },
    { value: "10F", label: "70G" },
    { value: "10FF", label: "70H" },
    { value: "10G", label: "70I" },
    { value: "10GG", label: "70J" },
    { value: "10H", label: "70K" },
    { value: "10HH", label: "70L" },
    { value: "10J", label: "70M" },
    { value: "12F", label: "75G" },
    { value: "12FF", label: "75H" },
    { value: "12G", label: "75I" },
    { value: "12GG", label: "75J" },
    { value: "12H", label: "75K" },
    { value: "12HH", label: "75L" },
    { value: "12J", label: "75M" },
    { value: "14D", label: "80D" },
    { value: "14F", label: "80G" },
    { value: "14FF", label: "80H" },
    { value: "14G", label: "80I" },
    { value: "14GG", label: "80J" },
    { value: "14H", label: "80K" },
    { value: "14J", label: "80M" },
    { value: "14K", label: "80O" },
    { value: "16E", label: "85F" },
    { value: "16F", label: "85G" },
    { value: "16FF", label: "85H" },
    { value: "16G", label: "85I" },
    { value: "16GG", label: "85J" },
    { value: "16H", label: "85K" },
    { value: "18F", label: "90G" },
    { value: "18FF", label: "90H" },
    { value: "18D", label: "90I" },
    { value: "18G", label: "90I" },
    { value: "18GG", label: "90J" },
    { value: "18J", label: "90M" },
    { value: "20F", label: "95G" },
    { value: "20FF", label: "95H" },
    { value: "20G", label: "95I" },
    { value: "22F", label: "95I" },
    { value: "22FF", label: "100G" },
    { value: "24F", label: "100H" }
];

$(document).ready(function() {
    if($('#page_name').val() == "asseen-page") {
        var options = "";
        bustSizeOptions.forEach(option => {
            options += "<option value='"+option.value+"'>"+option.label+"</option>";
        });
        $('.asseen-filter[data-fltrtype="purpletag"]').html(options);
        
        if($('.asseen-filter').length > 0) {
            $('.asseen-filter').on('change', function() {
                filterContent();
            });
        }
    }
    filterContent();
});

function filterContent() {
    fetch("https://shopify.cakematernity.com/shopify/data/asseen")
    .then(res => res.json())
    .then(data => {
        var html = "";
        if($('#page_name').val() == "asseen-page") {
            const selectedTag = $('.asseen-filter[data-fltrtype="purpletag"]').val();
            const selectedSize = $('.asseen-filter[data-fltrtype="size"]').val();
            const selectedProduct = $('.asseen-filter[data-fltrtype="product"]').val();
            
            const filtered = data.filter(item => {
                return (
                (selectedProduct === '' || item.prodtype === selectedProduct) &&
                (selectedSize === '' || item.size === selectedSize) &&
                (selectedTag === '' || item.purpletag === selectedTag)
                );
            });

            filtered.forEach(item => {
                html += `<div class="see-it-on-item" data-selector-1="" data-selector-2="" data-selector-3="">`;
                    html += `<div class="item-container">`;
                    if (item.images && item.images.length > 0) {
                        html += `<div class="img-cntr owl-carousel" id="img-cntr-${item.prod_selection}" data-stylecode="${item.prod_selection}">`;
                            item.images.forEach(image => {
                                html += `<a href="${item.url}" target="_blank">`;
                                    html += `<img src="https://assets.sugarcandybra.com/upload/asseen/${image}?tr=w-295,h-394">`;
                                html += `</a>`;
                            });
                        html += `</div>`;
                    }
                    if(item.social_media_handle) {
                        html += `<div class="dtls-cntr">`;
                            html += `<p class="dtls-txt-frst"><span class="sc-md-hndl"><a href="${item.url}" target="_blank">${item.social_media_handle}</a></span></p>`;
                            html += `<p class="dtls-txt-scnd">wears <span class="size">${item.size}</span>, usually <span class="actual_size">${item.purpletag}</span></p>`;
                        html += `</div>`;
                    }
                    html += `</div>`;
                html += `</div>`;

            });
            $('.items-container').html(html);

            reloadCarousel();
        } else {
            var prod_type = $('#prod_type').val();
            const filtered = data.filter(item => {
                return (
                (prod_type === '' || item.prodtype === prod_type)
                );
            });
            filtered.forEach(item => {
                var image_class = item.images && item.images.length > 0? "img-cntr owl-carousel" : "";
                html += `<div class="item-list">`;
                    html += `<div class="`+image_class+`" id="img-cntr-${item.prod_selection}" data-stylecode="${item.prod_selection}">`;
                        item.images.forEach(image => {
                            html += `<a href="${item.url}">`;
                                html += `<img src="https://assets.sugarcandybra.com/upload/asseen/${image}?tr=w-295,h-394" class="asseen-prod-img">`;
                            html += `</a>`;
                        });
                    html += `</div>`;
                    if(item.social_media_handle) {
                        html += `<div class="assen-on-prod-desc">`;
                            html += `<p><a href="${item.url}" class="instalink">${item.social_media_handle}</a></p>`;
                            html += `<p>wears ${item.size}, usually ${item.purpletag}</p>`;
                        html += `</div>`;
                    }
                html += `</div>`;

            });
            $('.asseen-prod-on-cont').html(html);

            var instagramSlider = {
                lazyLoad: true,
                lazyLoadEager: 1,
                nav: false,
                dots: false,
                autoplay: true,
                autoplayTimeout: 3000,
                loop: true,
                autoplayHoverPause : false,
                responsive:{
                    0:{
                        margin : 10,
                        items:1,
                        stagePadding: 40,
                        loop:false,
                        startPosition:1,

                    },
                    414:{
                        margin : 10,
                        items:1,
                        stagePadding: 90,
                        loop:false,
                        startPosition:1,

                    },
                    767:{
                        margin : 10,
                        items:4,
                        startPosition:0,
                        stagePadding: 10,
                        loop:false,
                    },
                    991:{
                        margin : 15,
                        items:4,
                        startPosition:0,
                        loop:false,
                        stagePadding: 40,
                    }
                },
            };
            $('.asseen-prod-on-cont').owlCarousel(instagramSlider);
            reloadCarousel();
            
        }
    });
}

function reloadCarousel(){
    if($('.img-cntr').length > 0){
        $(".img-cntr").each(function(index) {

            var asSeenSettings = {
                dots : true,
                nav: false,
                autoplay:false,
                responsive:{
                    0:{
                        items:1,
                    }
                },
                loop : false,
            };

            $(".img-cntr").owlCarousel(asSeenSettings);
            $(".img-cntr").on('mousedown.owl.core, touchstart.owl.core,', function(e){
                e.stopPropagation();
            });

        });
    }
}